export default "__VITE_PUBLIC_ASSET__74731062__"